import { render } from "./SpocCourseCard.vue?vue&type=template&id=65acccf8&scoped=true"
import script from "./SpocCourseCard.vue?vue&type=script&lang=js"
export * from "./SpocCourseCard.vue?vue&type=script&lang=js"

import "./SpocCourseCard.vue?vue&type=style&index=0&id=65acccf8&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-云南农业大学-前台页面/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65acccf8"]])

export default __exports__